__turbopack_context__.v({
  "component": "style-module-scss-module__rixj1G__component",
  "description": "style-module-scss-module__rixj1G__description",
});
